// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shortTips":"shortTips-3sFsCJkD","fhxwkhd":"fhxwkhd-ZLEa46xl"};